<template>
	




		<div>
			<div v-if="this.searchEntity" @click.stop="this.showDetails = !this.showDetails"
				style="background:var(--grey-5);display:inline-block;padding:5px;border-radius: 5px;">Score details {{
					searchEntity.search.totalScore
				}}</div>



			<div v-if="this.showDetails && searchEntity.search">

				<div class="flexcenter" style="align-items:baseline;">

					ImportantKeyWords: {{ searchEntity.importantKeywords.join(" ") }} <br />
					Keywords: {{ searchEntity.keywords.join(", ") }} <br />
					Text: {{ searchEntity.text }} <br />
				</div>
				<hr />
				<div
					v-for="(score, index) in searchEntity.search.scoreList.filter(score => score && score.score > 0).sort((a, b) => (b.score - a.score))"
					:key="index" style="background:var(--grey-5);padding:3px;margin-bottom:3px;border-radius: 5px;">

					{{ score.score }}: {{ score.description }}

				</div>

				<hr />
				<div v-if="searchEntity.search.showScoreList">
					<div v-for="(score, index) in searchEntity.search.scoreList" :key="index"
						style="background:var(--grey-5);padding:3px;margin-bottom:3px;border-radius: 5px;">

						{{ score.score }}: {{ score.description }}
					</div>
				</div>
			</div>
		</div>

</template>
<script>

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchResultProductScore",
	components: {},
	mixins: [],
	props: {
		productId: Number,
		searchEntity: Object
	},
	data() {
		return {
			showDetails: false
		};
	},
	computed: {


		product() {
			return this.$store.state.productStore.data.productList[this.productId]
		},

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped>
div#searchResultProductRow {
	background: var(--grey-3);
	border-radius: 5px;
	padding: 5px;
	margin-bottom: 5px;
}
</style>